﻿"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.InternalExchangerSPView = void 0;
const modalCom = require("@ivanlog/gs-com-modal_dialogs");
const com = require("../tmpls");
class InternalExchangerSPView extends com.CmpInternalExchanger {
    constructor(contract) {
        super();
        this._contract = contract;
        this.ctrls.lName.text = "Internal exchange SP";
        this.ctrls.btnRefresh.onclick = () => this.refresh();
        this.ctrls.btnInfo.onclick = () => new modalCom.DialogOk("Contract address: " + this._contract.address + "<br><br>" + this.ctrls.lFaqInfo.text, "Info").show();
    }
    refresh() {
        return __awaiter(this, void 0, void 0, function* () {
            this.ctrls.lBalancePLS.text = yield this._contract.getBalance();
        });
    }
}
exports.InternalExchangerSPView = InternalExchangerSPView;
//# sourceMappingURL=InternalExchangerSPView.js.map